export { MapZoomLevels } from './MapZoomLevels';
export { SIZES } from './sizes';



// WEBPACK FOOTER //
// ./src/app/shared/configs/index.ts